import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Regions} from './regions.model';

export const loadRegionss = createAction(
  '[Regions/API] Load Regionss',
  props<{ regionss: Regions[] }>()
);

export const addRegions = createAction(
  '[Regions/API] Add Regions',
  props<{ regions: Regions }>()
);

export const upsertRegions = createAction(
  '[Regions/API] Upsert Regions',
  props<{ regions: Regions }>()
);

export const addRegionss = createAction(
  '[Regions/API] Add Regionss',
  props<{ regionss: Regions[] }>()
);

export const upsertRegionss = createAction(
  '[Regions/API] Upsert Regionss',
  props<{ regionss: Regions[] }>()
);

export const updateRegions = createAction(
  '[Regions/API] Update Regions',
  props<{ regions: Update<Regions> }>()
);

export const updateRegionss = createAction(
  '[Regions/API] Update Regionss',
  props<{ regionss: Update<Regions>[] }>()
);

export const deleteRegions = createAction(
  '[Regions/API] Delete Regions',
  props<{ id: string }>()
);

export const deleteRegionss = createAction(
  '[Regions/API] Delete Regionss',
  props<{ ids: string[] }>()
);

export const clearRegionss = createAction(
  '[Regions/API] Clear Regionss'
);


// Custom Actions
export const getAllRegions = createAction(
  '[Regions/API] Get All Regions'
);
